

export const getErrorMessage = (error: Error | any, defaultMessage: string = 'Something went wrong') => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  return error instanceof Error ? error.message : defaultMessage;
};

/**
 * The server's own sentence, or null.
 *
 * Narrower than `getErrorMessage` above on purpose. That one always
 * returns a string and falls back to whatever the transport says,
 * which is right for a toast — something has to be shown once the
 * member has tapped. It is wrong for a screen that already has a
 * sensible resting state: "Request failed with status code 400" put
 * where "No availability" used to be is a downgrade, not a fix. So
 * anything the API did not author returns null and the caller keeps
 * its own copy.
 *
 * NestJS sends `message` as a string for a thrown HttpException and
 * as an array of strings for a DTO validation failure. Both shapes
 * reach this path, so both are read.
 */
export const getApiMessage = (error: unknown): string | null => {
  const message = (error as any)?.response?.data?.message;

  if (typeof message === 'string') return message.trim() || null;
  if (Array.isArray(message)) {
    const joined = message.filter((m) => typeof m === 'string').join(' ').trim();
    return joined || null;
  }
  return null;
};